<template>
  <b-container fluid>
    <el-page-header
      @back="goBack"
      :title="$l('INDEX.btn_go_back') || '返回'"
      :content="pageHeader"
    />
    <b-row class="mt-2">
      <b-col>
        <b-card>
          <!--基础信息-->
          <div style="font-size: 14px; color: #606266">
            <span>No：{{ formData.scmNo }}</span>
            <el-divider direction="vertical"></el-divider>
            <span>Status：{{ formData.scmStatusName }}</span>
            <el-divider direction="vertical"></el-divider>
            <span
              >Create：{{ formData.createByName }} at
              {{ formData.createDate }}</span
            >
            <el-divider direction="vertical"></el-divider>
            <span
              >Modify：{{ formData.modifyByName }} at
              {{ formData.modifyDate }}</span
            >
          </div>
          <div class="d2-mt">
            <el-form ref="form" :model="formData" :rules="rules">
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form ref="formData" :model="formData" :rules="rules">
                    <el-row :gutter="20">
                      <el-col
                        :sm="{ span: 24 }"
                        :md="{ span: 12 }"
                        :lg="{ span: 12 }"
                      >
                        <el-form-item
                          :label="
                            $l('form_label_supplier_name_cn') || '供应商名称'
                          "
                          prop="scmName"
                        >
                          <el-input
                            v-model="formData.scmName"
                            maxlength="4000"
                            :placeholder="
                              $l('INDEX.tips_input_placeholder') || '请输入'
                            "
                            :disabled="isViewDisabled"
                            clearable
                            size="medium"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col
                        :sm="{ span: 24 }"
                        :md="{ span: 12 }"
                        :lg="{ span: 12 }"
                      >
                        <el-form-item
                          :label="
                            $l('form_label_supplier_name_en') ||
                              '供应商英文名称'
                          "
                          prop="scmNameEn"
                        >
                          <el-input
                            v-model="formData.scmNameEn"
                            maxlength="4000"
                            :placeholder="
                              $l('INDEX.tips_input_placeholder') || '请输入'
                            "
                            :disabled="isViewDisabled"
                            clearable
                            size="medium"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col
                        :sm="{ span: 24 }"
                        :md="{ span: 8 }"
                        :lg="{ span: 8 }"
                      >
                        <el-form-item
                          :label="$l('form_label_province') || '所在省'"
                          prop="provinceCode"
                        >
                          <el-select
                            size="medium"
                            v-model="formData.provinceCode"
                            :disabled="isViewDisabled"
                            @change="loadCityOptions"
                            :placeholder="
                              $l('INDEX.tips_select_placeholder') || '请选择'
                            "
                            style="width: 100%"
                            filterable
                            clearable
                          >
                            <el-option
                              v-for="item in provinceOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col
                        :sm="{ span: 24 }"
                        :md="{ span: 8 }"
                        :lg="{ span: 8 }"
                      >
                        <el-form-item
                          :label="$l('form_label_city') || '所在市'"
                          prop="cityCode"
                        >
                          <el-select
                            size="medium"
                            v-model="formData.cityCode"
                            :disabled="isViewDisabled"
                            @change="loadDistrictOptions"
                            :placeholder="
                              $l('INDEX.tips_select_placeholder') || '请选择'
                            "
                            style="width: 100%"
                            filterable
                            clearable
                          >
                            <el-option
                              v-for="item in cityOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col
                        :sm="{ span: 24 }"
                        :md="{ span: 8 }"
                        :lg="{ span: 8 }"
                      >
                        <el-form-item
                          :label="$l('form_label_area') || '所在区/县'"
                          prop="districtCode"
                        >
                          <el-select
                            size="medium"
                            v-model="formData.districtCode"
                            :disabled="isViewDisabled"
                            :placeholder="
                              $l('INDEX.tips_select_placeholder') || '请选择'
                            "
                            style="width: 100%"
                            filterable
                            clearable
                          >
                            <el-option
                              v-for="item in districtOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col
                        :sm="{ span: 24 }"
                        :md="{ span: 16 }"
                        :lg="{ span: 16 }"
                      >
                        <el-form-item
                          :label="$l('form_label_address_detail') || '详细地址'"
                          prop="scmAddress"
                        >
                          <el-input
                            v-model="formData.scmAddress"
                            maxlength="500"
                            :placeholder="
                              $l('INDEX.tips_input_placeholder') || '请输入'
                            "
                            :disabled="isViewDisabled"
                            clearable
                            size="medium"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col
                        :sm="{ span: 24 }"
                        :md="{ span: 8 }"
                        :lg="{ span: 8 }"
                      >
                        <el-form-item
                          :label="
                            $l('form_label_supplier_category') || '厂商类别'
                          "
                        >
                          <el-select
                            size="medium"
                            v-model="formData.scmCategoryCode"
                            :disabled="isViewDisabled"
                            @change="selTemplateByScmCategoryCode"
                            style="width: 100%"
                            filterable
                            :placeholder="
                              $l('INDEX.tips_select_placeholder') || '请选择'
                            "
                            clearable
                          >
                            <el-option
                              v-for="item in categoryOption"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col
                        :sm="{ span: 24 }"
                        :md="{ span: 8 }"
                        :lg="{ span: 8 }"
                      >
                        <el-form-item
                          :label="
                            $l('form_label_supplier_businessLicense') ||
                              '统一社会征信代码'
                          "
                          prop="businessLicense"
                        >
                          <el-input
                            v-model="formData.businessLicense"
                            maxlength="500"
                            :placeholder="
                              $l('INDEX.tips_input_placeholder') || '请输入'
                            "
                            :disabled="isViewDisabled"
                            clearable
                            size="medium"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col
                        :sm="{ span: 24 }"
                        :md="{ span: 8 }"
                        :lg="{ span: 8 }"
                      >
                        <el-form-item
                          :label="
                            $l('form_label_supplier_bankName') || '开户银行'
                          "
                          prop="bankName"
                        >
                          <el-input
                            v-model="formData.bankName"
                            maxlength="500"
                            :placeholder="
                              $l('INDEX.tips_input_placeholder') || '请输入'
                            "
                            :disabled="isViewDisabled"
                            clearable
                            size="medium"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col
                        :sm="{ span: 24 }"
                        :md="{ span: 8 }"
                        :lg="{ span: 8 }"
                      >
                        <el-form-item
                          :label="
                            $l('form_label_supplier_bankAccountName') ||
                              '账户名称'
                          "
                        >
                          <el-input
                            v-model="formData.bankAccountName"
                            maxlength="500"
                            :placeholder="
                              $l('INDEX.tips_input_placeholder') || '请输入'
                            "
                            :disabled="isViewDisabled"
                            clearable
                            size="medium"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col
                        :sm="{ span: 24 }"
                        :md="{ span: 8 }"
                        :lg="{ span: 8 }"
                      >
                        <el-form-item
                          :label="
                            $l('form_label_supplier_bankAccountNo') ||
                              '银行账号'
                          "
                          prop="bankAccountNo"
                        >
                          <el-input
                            v-model="formData.bankAccountNo"
                            maxlength="500"
                            :placeholder="
                              $l('INDEX.tips_input_placeholder') || '请输入'
                            "
                            :disabled="isViewDisabled"
                            clearable
                            size="medium"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col
                        :sm="{ span: 24 }"
                        :md="{ span: 8 }"
                        :lg="{ span: 8 }"
                      >
                        <el-form-item
                          :label="
                            $l('form_label_supplier_bankAccountType') ||
                              '账户性质'
                          "
                          prop="bankAccountType"
                        >
                          <el-select
                            size="medium"
                            v-model="formData.bankAccountType"
                            :disabled="isViewDisabled"
                            :placeholder="
                              $l('INDEX.tips_select_placeholder') || '请选择'
                            "
                            style="width: 100%"
                            filterable
                            clearable
                          >
                            <el-option label="公司" value="0" />
                            <el-option label="个人" value="1" />
                          </el-select>
                        </el-form-item>
                      </el-col>

                      <el-col
                        :sm="{ span: 24 }"
                        :md="{ span: 8 }"
                        :lg="{ span: 8 }"
                      >
                        <el-form-item
                          :label="
                            $l('form_label_supplier_bankAccountKind') ||
                              '账号类别'
                          "
                          prop="bankAccountKind"
                        >
                          <dict-select
                            size="small"
                            clearable
                            filterable
                            :disabled="diversityFlag"
                            v-model="formData.bankAccountKind"
                            :placeholder="
                              $l('INDEX.tips_select_data') || '请选择...'
                            "
                            :body="bankAccountKindParams"
                            url="/master/common/dict/biz"
                          ></dict-select>
                        </el-form-item>
                      </el-col>

                      <el-col
                        :sm="{ span: 12 }"
                        :md="{ span: 12 }"
                        :lg="{ span: 12 }"
                      >
                        <el-form-item
                          :label="$l('form_label_remarks') || '工厂概况'"
                        >
                          <el-input
                            type="textarea"
                            :rows="4"
                            :disabled="isViewDisabled"
                            v-model="formData.scmMemo"
                            clearable
                            size="medium"
                            :placeholder="
                              $l('INDEX.tips_input_placeholder_factory') ||
                                '请输入工厂整体情况：年销售额、总产能、目前产能占比等背景情况'
                            "
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col
                        :sm="{ span: 12 }"
                        :md="{ span: 12 }"
                        :lg="{ span: 12 }"
                      >
                        <el-form-item
                          :label="$l('form_label_cooperation') || '合作意向'"
                        >
                          <el-input
                            type="textarea"
                            :rows="4"
                            :disabled="isViewDisabled"
                            v-model="formData.scmCooperation"
                            clearable
                            size="medium"
                            :placeholder="
                              $l('INDEX.tips_input_placeholder_cooperation') ||
                                '请输入合作意愿、配合度、专业性'
                            "
                          ></el-input>
                        </el-form-item>
                      </el-col>

                      <el-col
                        :sm="{ span: 12 }"
                        :md="{ span: 12 }"
                        :lg="{ span: 12 }"
                      >
                        <el-form-item
                          :label="
                            $l('form_label_certificate_info') || '相关证书'
                          "
                        >
                          <el-input
                            type="textarea"
                            :rows="4"
                            :disabled="isViewDisabled"
                            v-model="formData.certificateInfo"
                            clearable
                            size="medium"
                            :placeholder="
                              $l('INDEX.tips_input_placeholder_certificate') ||
                                '请输入环保方面的证书信息：GRS、OEKO-TEX、RCS、GOTS、OCS、RDS、FSC等'
                            "
                          ></el-input>
                        </el-form-item>
                      </el-col>

                      <el-col
                        :sm="{ span: 12 }"
                        :md="{ span: 12 }"
                        :lg="{ span: 12 }"
                      >
                        <el-form-item
                          :label="
                            $l('form_label_factory_inspection') || '工厂资质'
                          "
                        >
                          <el-input
                            type="textarea"
                            :rows="4"
                            :disabled="isViewDisabled"
                            v-model="formData.factoryInspection"
                            clearable
                            size="medium"
                            :placeholder="
                              $l(
                                'INDEX.tips_input_placeholder_qualifications'
                              ) ||
                                '请输入有哪些客户验厂、BSCI、质量体系SA8000、ISO90001等信息'
                            "
                          ></el-input>
                        </el-form-item>
                      </el-col>

                      <el-col
                        :sm="{ span: 12 }"
                        :md="{ span: 12 }"
                        :lg="{ span: 12 }"
                      >
                        <el-form-item
                          :label="$l('form_label_customer') || '适用客户'"
                        >
                          <el-input
                            type="textarea"
                            :rows="4"
                            :disabled="isViewDisabled"
                            v-model="formData.suitableForCustomers"
                            clearable
                            size="medium"
                            :placeholder="
                              $l('INDEX.tips_input_placeholder_customer') ||
                                '请输入适用于哪些客户'
                            "
                          ></el-input>
                        </el-form-item>
                      </el-col>

                      <el-col
                        :sm="{ span: 12 }"
                        :md="{ span: 12 }"
                        :lg="{ span: 12 }"
                      >
                        <el-form-item
                          :label="
                            $l('form_label_main_categories') || '主要品类'
                          "
                        >
                          <el-input
                            type="textarea"
                            :rows="4"
                            :disabled="isViewDisabled"
                            v-model="formData.scmProductCategory"
                            clearable
                            size="medium"
                            :placeholder="
                              $l('INDEX.tips_input_placeholder_categories') ||
                                '请输入合作意愿、配合度、专业性'
                            "
                          ></el-input>
                        </el-form-item>
                      </el-col>

                      <el-col
                        :sm="{ span: 12 }"
                        :md="{ span: 12 }"
                        :lg="{ span: 12 }"
                      >
                        <el-form-item
                          :label="
                            $l('form_label_main_recommendation') || '推荐指数'
                          "
                        >
                          <br />
                          <el-rate v-model="formData.ourRatings"> </el-rate>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <Attribute
                        size="medium"
                        :span="8"
                        ref="attribute"
                        :disabled="isViewDisabled"
                        :params="attrParams"
                      />
                    </el-row>
                  </el-form>
                </el-col>
                <!-- <el-col :span="10">
                  <el-row>
                    <el-col
                      :sm="{ span: 24 }"
                      :md="{ span: 24 }"
                      :lg="{ span: 24 }"
                    >
                      <uploader-image
                        :multiple="false"
                        :thumbnail="{ quality: 0.2 }"
                        :on-added="onAdded"
                        :data="{
                          url: $osscdn(formData.scmImageCode),
                          turl: $osscdn(formData.scmThumbImageCode),
                        }"
                      ></uploader-image>
                    </el-col>
                  </el-row>
                </el-col> -->
              </el-row>
            </el-form>
          </div>
          <div class="d2-mt">
            <contacts ref="contacts" />
          </div>
          <div class="d2-mt">
            <el-row>
              <el-col :span="8">
                <el-button @click="goBack()" size="small">{{
                  $l('INDEX.btn_go_back') || '返回'
                }}</el-button>
                <el-button
                  @click="save"
                  type="primary"
                  size="small"
                  v-if="!isViewDisabled"
                  >{{ $l('INDEX.btn_save') || '保存' }}</el-button
                >
              </el-col>
            </el-row>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card style="display: none">
          <b-row>
            <b-col cols="auto" class="mr-auto p-2">
              <h6 class="card-title mb-0">
                {{ $l('card_picturesAndInformation') || '图片及资料' }}
              </h6>
            </b-col>
            <b-col cols="auto" class="p-2 mr-1">
              <a
                :disabled="!formData.scmCode"
                v-b-toggle.collapse-3
                role="button"
              >
                <i v-if="visible_3" class="fa fa-chevron-down" title="收起"></i>
                <i v-else class="fa fa-chevron-up" title="展开"></i>
              </a>
            </b-col>
          </b-row>
          <b-collapse v-model="visible_3" id="collapse-3">
            <div class="d2-mt">
              <doc ref="doc" />
            </div>
          </b-collapse>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card style="display: none">
          <b-row>
            <b-col cols="auto" class="mr-auto p-2">
              <h6 class="card-title mb-0">
                {{ $l('card_visitRecord') || '拜访记录' }}
              </h6>
            </b-col>
            <b-col cols="auto" class="p-2 mr-1">
              <a
                :disabled="!formData.scmCode"
                v-b-toggle.collapse-4
                role="button"
              >
                <i v-if="visible_4" class="fa fa-chevron-down" title="收起"></i>
                <i v-else class="fa fa-chevron-up" title="展开"></i>
              </a>
            </b-col>
          </b-row>
          <b-collapse v-model="visible_4" id="collapse-4">
            <div class="d2-mt">
              <visit ref="visit" />
            </div>
          </b-collapse>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card style="display: none">
          <b-row>
            <b-col cols="auto" class="mr-auto p-2">
              <h6 class="card-title mb-0">
                {{ $l('card_evaluationRecord') || '评价记录' }}
              </h6>
            </b-col>
            <b-col cols="auto" class="p-2 mr-1">
              <a
                :disabled="!formData.scmCode"
                v-b-toggle.collapse-5
                role="button"
              >
                <i v-if="visible_5" class="fa fa-chevron-down" title="收起"></i>
                <i v-else class="fa fa-chevron-up" title="展开"></i>
              </a>
            </b-col>
          </b-row>
          <b-collapse v-model="visible_5" id="collapse-5">
            <div class="d2-mt">
              <appraisal ref="appraisal" />
            </div>
          </b-collapse>
        </b-card>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改?' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="back()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button type="primary" @click="backSave()" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </b-container>
</template>
<script>
import contacts from './components/contacts/contacts'
import doc from './components/doc/doc'
import visit from './components/visit/visit'
import appraisal from './components/appraisal/appraisal'
import util from '@/libs/util'
import Attribute from '@/views/digital/components/attribute'
import validate from '@/libs/util.validate'
export default {
  components: {
    contacts,
    doc,
    visit,
    appraisal,
    Attribute,
  },
  data() {
    return {
      texts: ['一星', '二星', '三星', '四星', '五星'],
      visible_1: true,
      visible_3: false,
      visible_4: false,
      visible_5: false,
      // 图片压缩比例
      imgQuality: 0.25,
      pageHeader: '',
      isViewDisabled: false,
      dialogVisible: false,
      activeName: 'basic',
      cityVaild: true,
      districtValid: true,
      scmInputTemplateData: {},
      bankAccountKindParams: { dictType: 'bankAccountKind' },
      formData: {
        scmCode: '', // 供应商编码
        scmNo: '', // 供应商编号
        scmName: '', // 供应商名称
        scmNameEn: '', // 供应商英文名称
        scmCategoryCode: '', // 供应商分类编码
        regionCode: '100000', // 国家地区编码
        regionName: '中国', // 国家地区名称
        provinceCode: '', // 省份编码
        cityCode: '', // 城市编码
        districtCode: '', // 区县编码
        scmAddress: '', // 详细地址
        scmImageCode: '', // 供应商图片
        scmImageUrl: '', // 供应商图片url
        scmThumbImageCode: '', // 厂商图片缩略图
        scmThumbImageUrl: '', // 厂商图片缩略图url
        scmMemo: '', // 备注说明
        scmStatus: '', // 有效状态
        createDate: '', // 创建时间
        modifyDate: '', // 修改时间
      },
      btnFlag: '',
      fileData: {
        // abs文件上传参数
        expirationsec: 0,
        fileproperty: 'publicfiles',
      },
      fileHeaders: {
        // 文件上传请求头
        tokenTimeOut: 0,
        token: util.token.getToken(),
      },
      provinceOptions: [], //  省份
      cityOptions: [], //  市
      districtOptions: [], //  县
      categoryOption: [], // 供应商类别下拉
      rules: {
        scmName: [
          {
            required: true,
            message:
              this.$l('form_label_supplierName_tips') || '请输入供应商名称',
            trigger: 'blur',
          },
        ],
        businessLicense: [
          {
            required: true,
            message:
              this.$l('form_label_supplierBusinessLicense_tips') ||
              '请输入统一社会征信代码',
            trigger: 'blur',
          },
        ],
        bankAccountKind: [
          {
            required: true,
            message:
              this.$l('form_label_supplierBankAccountKind_tips') ||
              '请输入账号类别',
            trigger: 'blur',
          },
        ],
        bankAccountNo: [
          {
            required: true,
            message:
              this.$l('form_label_supplierBankAccountNo_tips') ||
              '请输入银行账号',
            trigger: 'blur',
          },
        ],
        bankName: [
          {
            required: true,
            message:
              this.$l('form_label_supplierBankName_tips') || '请输入开户银行',
            trigger: 'blur',
          },
        ],
        bankAccountType: [
          {
            required: true,
            message:
              this.$l('form_label_supplierBankAccountType_tips') ||
              '请输入账户性质',
            trigger: 'blur',
          },
        ],

        // provinceCode: [
        //   {
        //     required: true,
        //     message: this.$l("form_label_province_tips") || "请选择所在省份",
        //     trigger: "change",
        //   },
        // ],
        // cityCode: [
        //   {
        //     required: true,
        //     message: this.$l("form_label_city_tips") || "请选择所在市",
        //     trigger: "change",
        //   },
        // ],
        // districtCode: [
        //   {
        //     required: true,
        //     message: this.$l("form_label_area_tips") || "请选择区/县",
        //     trigger: "change",
        //   },
        // ],
        scmAddress: [
          {
            required: true,
            message:
              this.$l('form_label_addressDetail_tips') || '请填写详细地址',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    attrParams() {
      return {
        infoCode: this.formData.scmCode,
        templateCategoryCode: this.formData.scmCategoryCode,
        masterCategoryCode: this.formData.scmCategoryCode,
        templateType: 'S',
      }
    },
  },
  mounted() {
    let type = this.$route.params.type
    let scmCode = this.$route.params.scmCode
    this.init(type, scmCode)
  },
  activated() {
    let type = this.$route.params.type
    let scmCode = this.$route.params.scmCode
    this.init(type, scmCode)
  },
  methods: {
    onAdded({ md5, isThumb, suffix }) {
      let code = md5 + '.' + suffix
      if (isThumb) {
        this.formData.scmImageCode = code
      } else {
        this.formData.scmThumbImageCode = code
      }
    },
    init(type, scmCode) {
      this.reset()
      this.type = type
      this.scmCode = scmCode
      if (this.type === 'edit') {
        this.updateLoad(scmCode)
      } else if (this.type === 'detail') {
        this.detailLoad(scmCode)
      } else if (this.type === 'add') {
        this.addLoad(scmCode)
      } else if (this.type === 'regularApply') {
        this.appleLoad(scmCode)
      }
    },
    reset() {
      this.isViewDisabled = false
      this.dialogVisible = false
      this.activeName = 'basic'
      this.btnFlag = ''
      this.type = ''
      this.scmCode = ''
      this.cityVaild = true
      this.districtValid = true
      this.scmInputTemplateData = {}
      this.formData = {
        scmCode: '', // 供应商编码
        scmNo: '', // 供应商编号
        scmName: '', // 供应商名称
        scmCategoryCode: '', // 供应商分类编码
        regionCode: '100000', // 国家地区编码
        regionName: '中国', // 国家地区名称
        provinceCode: '', // 省份编码
        cityCode: '', // 城市编码
        districtCode: '', // 区县编码
        scmAddress: '', // 详细地址
        scmImageCode: '', // 供应商图片
        scmImageUrl: '', // 供应商图片url
        scmMemo: '', // 备注说明
        scmStatus: '', // 有效状态
        createDate: '', // 创建时间
        modifyDate: '', // 修改时间
      }
      this.provinceOptions = [] //  省份
      this.cityOptions = [] //  市
      this.districtOptions = [] //  县
      this.categoryOption = [] // 供应商类别下拉
      this.loadSelect()
    },
    // 获取供应商类别下拉
    loadSelect() {
      this.$api
        .scmCategoryOptionApi({})
        .then((res) => {
          this.categoryOption = res.body.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    detailLoad(val) {
      this.reset()
      this.btnFlag = 'detail'
      this.pageHeader = this.$l('page_detail') || '供应商信息详情'
      this.isViewDisabled = true
      let param = { scmCode: val }
      this.$api.scmInfoDetailApi(param).then((res) => {
        this.formData = res.body
        this.loadProvinceOptions()
        this.$refs.attribute.load(this.attrParams)
        this.loadOtherData()
      })
    },
    addLoad(val) {
      if (this.$refs.formData) {
        this.$refs.formData.resetFields()
      }
      this.btnFlag = 'add'
      this.formData.scmCategoryCode = ''
      this.formData.scmStatus = 'Y'
      this.loadProvinceOptions()
      this.pageHeader = this.$l('page_add') || '供应商信息添加'
      this.isViewDisabled = false
      this.$refs.attribute.load(this.attrParams)
    },
    updateLoad(val) {
      this.reset()
      this.btnFlag = 'update'
      this.pageHeader = this.$l('page_edit') || '供应商信息修改'
      this.isViewDisabled = false
      let param = { scmCode: val }
      this.$api.scmInfoDetailApi(param).then((res) => {
        this.formData = res.body
        this.loadProvinceOptions()
        this.$refs.attribute.load(this.attrParams)
        this.loadOtherData()
      })
    },
    appleLoad(val) {
      this.reset()
      this.btnFlag = 'apple'
      this.pageHeader = this.$l('page_apple') || '供应商转正申请'
      this.isViewDisabled = false
      let param = { scmCode: val }
      this.$api.scmInfoDetailApi(param).then((res) => {
        this.formData = res.body
        this.loadProvinceOptions()
        this.$refs.attribute.load(this.attrParams)
        this.loadOtherData()
      })
    },
    loadOtherData() {
      this.$refs['contacts'].init(this.formData.scmCode, this.isViewDisabled)
      this.$refs['doc'].init(this.formData.scmCode, this.isViewDisabled)
      this.$refs['visit'].init(this.formData.scmCode, this.isViewDisabled)
      this.$refs['appraisal'].init(this.formData.scmCode, this.isViewDisabled)
    },
    save() {
      // if (this.$route.params.type === 'regularApply') {
      //   this.regularApply()
      // } else {
      this.saveData()
      // }
    },
    // 转正申请
    regularApply(val) {
      this.$api
        .scmInfoAppleApi({
          scmCode: val,
          linkUrl: this.$joinURL(`/opview/scm/${val}`, {
            joinOrigin: true,
            joinBasePath: false,
          }),
        })
        .then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_apple_ok') || '申请成功',
            type: 'success',
          })
          this.back()
        })
    },
    saveData() {
      const form = this.$refs.formData
      const attrForm = this.$refs.attribute.$refs.form
      validate.formValidate([form, attrForm], (valid) => {
        if (valid) {
          this.formData.attrData = this.$refs.attribute.getFormData()
          this.$api.scmInfoSaveApi(this.formData).then((res) => {
            this.formData.scmCode = res.body
            if (this.$route.params.type === 'regularApply') {
              this.regularApply(res.body)
            } else {
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_save_ok') || '保存成功',
                type: 'success',
              })
              this.back()
              // if (this.btnFlag === 'add') {
              //   // 新增页面保存后不返回
              //   this.updateLoad(this.formData.scmCode)
              // } else {
              //   this.back()
              // }
            }
          })
        }
      })
    },
    // 省份下拉
    loadProvinceOptions() {
      let regionDictParam = { levelType: '1', parentId: '0' }
      // 省份下拉
      this.$api
        .baseRegion(regionDictParam)
        .then((res) => {
          this.provinceOptions = res.body.data
          this.loadCityOptions()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 市级下拉
    loadCityOptions() {
      let regionDictParam = {
        levelType: '2',
        parentId: this.formData.provinceCode,
      }
      if (
        regionDictParam.parentId !== null &&
        regionDictParam.parentId !== ''
      ) {
        this.$api.baseRegion(regionDictParam).then((res) => {
          this.cityOptions = res.body.data
          if (this.cityVaild === false) {
            this.formData.cityCode = ''
            this.formData.districtCode = ''
          }
          this.loadDistrictOptions()
          this.cityVaild = false
        })
      } else {
        this.formData.cityCode = ''
        this.formData.districtCode = ''
        this.cityOptions = []
        this.districtOptions = []
      }
    },
    // 县级下拉
    loadDistrictOptions() {
      let regionDictParam = {
        levelType: '3',
        parentId: this.formData.cityCode,
      }
      if (
        regionDictParam.parentId !== null &&
        regionDictParam.parentId !== ''
      ) {
        this.$api.baseRegion(regionDictParam).then((res) => {
          this.districtOptions = res.body.data
          if (this.districtValid === false) {
            this.formData.districtCode = ''
          }
          this.districtValid = false
        })
      } else {
        this.formData.districtCode = ''
        this.districtOptions = []
      }
    },
    // 文件上传
    handleAvatarSuccess(res, file) {
      if (res.status === 200) {
        this.formData.scmImageCode = res.body.fileId
        this.formData.scmImageUrl = res.body.url
      }
    },
    // 缩略图上传
    handleAvatarSuccess1(res, file) {
      if (res.status === 200) {
        this.formData.scmThumbImageCode = res.body.fileId
        this.formData.scmThumbImageUrl = res.body.url
      }
    },
    beforeAvatarUpload(file) {
      const fileSize = file.size / 1024 / 1024 < 0.5
      if (!fileSize) {
        return new Promise((resolve) => {
          const reader = new FileReader()
          const image = new Image()
          image.onload = (imageEvent) => {
            const canvas = document.createElement('canvas')
            const context = canvas.getContext('2d')
            // const width = image.width * this.imgQuality
            // const height = image.height * this.imgQuality
            const width = 200
            const height = image.height * (200 / image.width)
            canvas.width = width
            canvas.height = height
            context.clearRect(0, 0, width, height)
            context.drawImage(image, 0, 0, width, height)
            const dataUrl = canvas.toDataURL(file.type)
            const blobData = this.dataURItoBlob(dataUrl, file.type)
            resolve(blobData)
          }
          reader.onload = (e) => {
            image.src = e.target.result
          }
          reader.readAsDataURL(file)
        })
      }
    },
    dataURItoBlob(dataURI, type) {
      var binary = atob(dataURI.split(',')[1])
      var array = []
      for (var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i))
      }
      return new Blob([new Uint8Array(array)], { type: type })
    },
    // 根据供应商类别查询供应商属性输入模板接口
    selTemplateByScmCategoryCode() {
      let scmInputTemplateParam = {
        scmCategoryCode: this.formData.scmCategoryCode,
      }
      this.$api
        .scmInputTemplateSelTemByScmCategoryCodeApi(scmInputTemplateParam)
        .then((res) => {
          this.scmInputTemplateData = res.body
          if (this.scmInputTemplateData === null) {
            // this.$message.info('此类别暂无供应商属性输入模板')
          }
          console.log(this.scmInputTemplateData)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    changeTabs() {
      if (this.activeName !== 'basic') {
        this.$refs[this.activeName].init(
          this.formData.scmCode,
          this.isViewDisabled
        )
      }
    },
    goBack() {
      if (this.isViewDisabled) {
        this.back()
        return
      }
      this.dialogVisible = true
    },
    back() {
      history.back()
      this.dialogVisible = false
      // this.init()
      this.$refs.formData.resetFields()
    },
    backSave() {
      this.dialogVisible = false
      this.save()
      // this.init()
    },
  },
}
</script>

<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
.scmInfo-uploader {
  border: 1px dashed #d9d9d9;
  width: 270px !important;
  height: 180px;
  line-height: 180px !important;
  text-align: center;
}
.avatarEvent-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 270px !important;
  height: 180px;
  line-height: 180px !important;
  text-align: center;
}

.avatarEvent {
  width: 270px !important;
  height: 180px;
  display: block;
}

.thumbnail-uploader {
  border: 1px dashed #d9d9d9;
  width: 180px !important;
  height: 120px;
  line-height: 120px !important;
  text-align: center;
}
.thumbnail-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 180px !important;
  height: 120px;
  line-height: 120px !important;
  text-align: center;
}

.thumbnail {
  width: 180px !important;
  height: 120px;
  display: block;
}
.top-scroll {
  height: 100%;
  overflow: hidden;
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>
